
import {
    GET_ADMIN_STATS,
    GET_ADMIN_STATS_SUCCESS,
    GET_ADMIN_STATS_FAIL
} from "./actionTypes"

export const getAdminStats = () => ({
    type: GET_ADMIN_STATS,
})

export const getAdminStatsSuccess = stats => ({
    type: GET_ADMIN_STATS_SUCCESS,
    payload: stats,
})

export const getAdminStatsFail = error => ({
    type: GET_ADMIN_STATS_FAIL,
    payload: error,
})
